import React from 'react'
import MetaTags from 'react-meta-tags'
import { connect } from 'react-redux'
import {Route, Switch} from 'react-router'
// import AnimatedRouterSwitch from '../../../../core/components/animated-router-switch/AnimatedRouterSwitch'
import {toJS} from '../../../../util/ToJS'
import {
  getProfileProblems,
  getProfileContributions,
  getUserInfo,
  resetProfileData
} from '../../../../redux/modules/profile'
import {getJourney, resetJourney} from '../../../../redux/modules/journey'
import VisibleProblemFeed from '../../../user/containers/VisibleProblemFeed'
import VisibleContributionsFeed from '../../../user/containers/VisibleContributionsFeed'
import VisibleJourney from '../journey/containers/VisibleJourney'
import LoggedIn from '../components/LoggedIn'
import {withRouter} from 'react-router'

class VisibleLoggedInComponent extends React.PureComponent {
  componentDidMount() {
    const {
      getProfileProblems,
      getProfileContributions,
      getUserInfo,
      resetProfileData,
      currUserId,
      getJourney
    } = this.props
    resetProfileData()
    getUserInfo(currUserId)
    getProfileProblems(currUserId)
    getProfileContributions(currUserId)
    getJourney()
  }
  /*componentWillReceiveProps(nextProps) {
    const {
      match,
      getProfileProblems,
      getProfileContributions,
      getUserInfo,
      resetProfileData,
      location
    } = this.props
    // const userId = match.params.userId;
    // const newUserId = nextProps.match.params.userId;
    //
    // if (userId !== newUserId) {
    //   resetProfileData();
    //   getUserInfo(newUserId);
    //   getProfileProblems(newUserId);
    //   getProfileContributions(newUserId);
    // }
  }*/
  render() {
    const {
      getProfileProblems,
      getProfileContributions,
      currUserId
    } = this.props
    const showMoreProblems = () => {
      getProfileProblems(currUserId)
    }
    const showMoreContributions = () => {
      getProfileContributions(currUserId)
    }
    return (
      <LoggedIn>
        <MetaTags>
          <title>Expii - Learn Creatively</title>
          <meta name="og:title" content="Expii - Learn Creatively" />
          <meta name="description" content="Expii is a free personalized learning website with thousands of math and science lessons, providing diverse ways to learn each topic, through interactive explanations and video." />
          <meta name="og:description" content="Expii is a free personalized learning website with thousands of math and science lessons, providing diverse ways to learn each topic, through interactive explanations and video." />
        </MetaTags>
        <Switch>
          <Route exact path="/"
            component={(props)=>(
              <VisibleJourney
                showMore={showMoreProblems}
                {...props}
              />
            )} />
          <Route exact path="/problems"
            component={(props)=>(
              <VisibleProblemFeed
                showMore={showMoreProblems}
                showPrivacy={false}
                {...props}
              />
            )} />
          <Route exact path="/contributions"
            component={(props)=>(
              <VisibleContributionsFeed
                showMore={showMoreContributions}
                showPrivacy={false}
                {...props}
              />
            )}
          />
        </Switch>
      </LoggedIn>
    )
  }
}

const mapStateToProps = state => {
  return {
    currUserId: state.getIn(['session', 'user', 'id'])
  }
}
const mapDispatchToProps = dispatch => ({
  getProfileProblems: userId => dispatch(getProfileProblems(userId)),
  getProfileContributions: userId => dispatch(getProfileContributions(userId)),
  getUserInfo: userId => dispatch(getUserInfo(userId)),
  resetProfileData: () => {
    dispatch(resetProfileData())
    dispatch(resetJourney())
  },
  getJourney: () => dispatch(getJourney(false))
})
const VisibleLoggedIn = withRouter(connect(mapStateToProps, mapDispatchToProps)(
  toJS(VisibleLoggedInComponent)
))

export default VisibleLoggedIn



// WEBPACK FOOTER //
// ./src/domains/home/logged-in-home/containers/VisibleLoggedIn.js